import axios from "axios";
import { SETTINGS } from "../../Settings";

export const ReportRepository = {
  generateReport: (request) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/reports/generate`,
      method: "POST",
      data: request,
      responseType: "blob",
    });
  },
};
